const STORE_RESOURCE_DETAILS = 'STORE_EDIT_RESOURCE_DETAILS';
const CLEAR_EDIT_RESOURCE_DETAILS = 'CLEAR_EDIT_RESOURCE_DETAILS';

export default STORE_RESOURCE_DETAILS;
export {
  CLEAR_EDIT_RESOURCE_DETAILS,
};
